import {
    Trash2,
    Check,
    Mic,
    MicOff,
    RefreshCw,
    Hourglass,
    Megaphone,
    CheckCircle2,
    XCircle,
    User2,
    Clock,
    Repeat,
    ArrowRight,
    ListOrdered,
    Loader2,
} from 'lucide-react';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import TranfertOpe from './TranfertOpe';
import datas from "../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import { queueHub } from '../../Services/signalr';
import { loadConfigAnnonce, AnnonceConfig } from '../../Functions/annonces';
import { annoncer } from '../../Ecran/voix';
import { performLogout } from '../../Functions/session';
import { useSignOut } from 'react-auth-kit';
import { Button, IconButton, Tooltip, Spin, SearchInput, useAlert, TableStatusBar, PageHeader } from '../ui';

// Helpers de statut
const STATUS_META: Record<number, { label: string; badge: string }> = {
    1: { label: 'Nouveau', badge: 'new' },
    2: { label: 'Validé', badge: 'validated' },
    3: { label: 'Rejeté', badge: 'rejected' },
    4: { label: 'Appelé', badge: 'called' },
    5: { label: 'Transféré', badge: 'transferred' },
};

function StatusBadge({ statut }: { statut: number }) {
    const meta = STATUS_META[statut] || { label: 'Inconnu', badge: 'new' };
    return <span className={`eb-queue-item-badge ${meta.badge}`}>{meta.label}</span>;
}

export default function CaisseTable() {
    // USER TOKEN
    const authHeader = useAuthHeader();
    const signOut = useSignOut();

    const [data, setData] = useState<any[]>([]);
    const [loading, selLoading] = useState(false);
    const [textRes, setTextRes] = useState("");
    const [calling, setCalling] = useState(false);
    const [curentTicket, setCurentTicket] = useState("");

    // Config d'annonce (VOIX_APPEL + MODE_ANNONCE) — le guichet ne parle
    // qu'en mode LOCAL ou LES_DEUX
    const annonceCfg = useRef<AnnonceConfig>({ vitesse: 1, mode: 'CENTRALISE' })

    // ALERTS
    const alert = useAlert();

    // USER SESSION
    const auth = useAuthUser();
    const user: User = JSON.parse(JSON.stringify(auth() || {}));

    async function CallClient(NumeroFile: string, generateBy: string) {
        setCalling(true);
        // CodeU / CodeOperateur sont lus dans le jeton agent — ne plus les envoyer
        let data = JSON.stringify({
            "CodeT": NumeroFile,
            "CodeAbonne": user.CodeAbonne,
            "CodeS": user.CodeS,
            "CodeFiliale": user.CodeFiliale
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Call,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
            },
            data: Crypter.encrypt(data)
        };

        await axios.request(config)
            .then((response) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                    setCurentTicket(NumeroFile);
                    alert.success(res.Message.split('|')[1] || res.Message);
                    // Voix UNIQUEMENT depuis la réponse de Call (modes LOCAL / LES_DEUX)
                    // — jamais depuis TicketCalled, sinon le poste annoncerait les
                    // appels des autres guichets.
                    if (res.Result?.JouerSurPoste === true) {
                        annoncer(res.Result?.Annonces || [], annonceCfg.current.vitesse)
                    }
                }
                else if (res.StatutCode == 403) {
                    // Session expirée → retour à l'écran de connexion
                    alert.warning(res.Message)
                    performLogout(signOut, authHeader())
                }
                else {
                    alert.warning(res.Message);
                }
                setCalling(false);
            })
            .catch((error) => {
                setCalling(false);
                alert.warning(error.message);
            });
    }

    useEffect(() => {
        LoadData(true);
        // Config d'annonce vocale — rafraîchie périodiquement
        const loadCfg = () => loadConfigAnnonce(authHeader, user.CodeFiliale, user.CodeS)
            .then((c) => { annonceCfg.current = c })
            .catch(() => { })
        loadCfg()
        const cfgTimer = setInterval(loadCfg, 5 * 60 * 1000)
        return () => clearInterval(cfgTimer)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // SignalR /hubs/queue — la file se rafraîchit sur événements, plus de polling
    useEffect(() => {
        const getJwt = () => (authHeader() || '').replace(/^Bearer\s+/i, '')
        const scope = { codeAbonne: user.CodeAbonne, codeFiliale: user.CodeFiliale, codeS: user.CodeS }
        queueHub.acquire(getJwt, scope).catch(() => { })

        const events = ['FileUpdated', 'QueueSnapshot', 'TicketCalled', 'TicketValidated',
            'TicketRejected', 'TicketTransferred', 'TicketNoShow', 'TicketCancelled']
        const unsubs = events.map((ev) => queueHub.on(ev, () => LoadData(false)))
        // Pas d'annonce vocale ici : le poste ne parle que depuis la réponse
        // de son propre appel (Result.JouerSurPoste) — jamais pour un autre guichet.

        return () => {
            unsubs.forEach((u) => u())
            queueHub.release()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function LoadData(load: boolean) {
        if (load) {
            selLoading(true);
        }
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.TicketsByService + Crypter.encrypt(JSON.stringify({ "CodeAbonne": user.CodeAbonne, "CodeFiliale": user.CodeFiliale, "CodeS": user.CodeS, "CodeU": user.CodeU })),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                    selLoading(false);
                    setTextRes(res.Result.length + ' Resultat(s) obtenu');
                    setData(res.Result);
                }
                else {
                    selLoading(false);
                    setTextRes("");
                    alert.warning(res.Message);
                }
            })
            .catch((error: any) => {
                setTextRes("");
                alert.warning(error.message);
                selLoading(false);
            });
    }

    function RejetOpe(reccord: any) {
        let data = JSON.stringify({
            "CodeT": reccord.CodeT,
            "CodeU": reccord.CodeU,
            "CodeOperateur": user.CodeU,
            "CodeAbonne": user.CodeAbonne,
            "CodeS": user.CodeS,
            "CodeFiliale": user.CodeFiliale
        });

        let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Reject,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
            },
            data: Crypter.encrypt(data)
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode != 200) {
                    selLoading(false);
                    setData([]);
                    setTextRes("");
                    alert.warning(res.Message);
                }
                else {
                    alert.success(res.Message);
                    if (reccord.CodeT === curentTicket) setCurentTicket("");
                    LoadData(false);
                }
            })
            .catch((error: any) => {
                setTextRes("");
                alert.warning(error.message);
            });
    }

    function ValidateOpe(reccord: any) {
        let data = JSON.stringify({
            "CodeT": reccord.CodeT,
            "CodeU": reccord.CodeU,
            "CodeOperateur": user.CodeU,
            "CodeAbonne": user.CodeAbonne,
            "CodeS": user.CodeS,
            "CodeFiliale": user.CodeFiliale
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Validate,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
            },
            data: Crypter.encrypt(data)
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode != 200) {
                    selLoading(false);
                    setData([]);
                    setTextRes("");
                    alert.warning(res.Message);
                }
                else {
                    alert.success(res.Message);
                    if (reccord.CodeT === curentTicket) setCurentTicket("");
                    LoadData(false);
                }
            })
            .catch((error: any) => {
                setTextRes("");
                alert.warning(error.message);
            });
    }

    // Statistiques rapides
    const stats = {
        waiting: data.filter((t: any) => t.Statut == 1).length,
        called: data.filter((t: any) => t.Statut == 4).length,
        validated: data.filter((t: any) => t.Statut == 2).length,
        rejected: data.filter((t: any) => t.Statut == 3).length,
    };

    // Ticket en cours d'appel
    const currentRecord = data.find((t: any) => t.CodeT === curentTicket);

    // Prochain ticket : le premier en attente (Statut == 1) ou le premier appelé par l'utilisateur
    const nextRecord = data.find((t: any) => t.Statut == 1) || data.find((t: any) => t.Statut == 4 && String(t.CodeOperateur).replace(" (👱🏼‍♂️ Moi)", "") == user.CodeU);

    // Vérifie si l'utilisateur peut interagir avec le ticket
    function canInteract(record: any): boolean {
        return record.Statut == 1 ||
            (((record.Statut == 4) || (record.Statut == 5)) &&
                (String(record.CodeOperateur).replace(" (👱🏼‍♂️ Moi)", "") == user.CodeU));
    }

    return (
        <Spin spinning={loading}>
            <PageHeader
                title="Espace opérationnel"
                subtitle="Gérez les appels et les tickets en cours"
                actions={
                    <Button
                        size="sm"
                        variant="outline"
                        startIcon={<RefreshCw size={16} />}
                        onClick={() => LoadData(true)}
                    >
                        Actualiser
                    </Button>
                }
            />

            <div className="eb-ticket-board">
                {/* Statistiques + contrôle vitesse */}
                <div className="eb-ticket-stats">
                    <div className="eb-ticket-stat">
                        <div className="eb-ticket-stat-icon waiting"><Hourglass size={18} /></div>
                        <div>
                            <div className="eb-ticket-stat-value">{stats.waiting}</div>
                            <div className="eb-ticket-stat-label">En attente</div>
                        </div>
                    </div>
                    <div className="eb-ticket-stat">
                        <div className="eb-ticket-stat-icon called"><Megaphone size={18} /></div>
                        <div>
                            <div className="eb-ticket-stat-value">{stats.called}</div>
                            <div className="eb-ticket-stat-label">Appelés</div>
                        </div>
                    </div>
                    <div className="eb-ticket-stat">
                        <div className="eb-ticket-stat-icon done"><CheckCircle2 size={18} /></div>
                        <div>
                            <div className="eb-ticket-stat-value">{stats.validated}</div>
                            <div className="eb-ticket-stat-label">Validés</div>
                        </div>
                    </div>
                    <div className="eb-ticket-stat">
                        <div className="eb-ticket-stat-icon reject"><XCircle size={18} /></div>
                        <div>
                            <div className="eb-ticket-stat-value">{stats.rejected}</div>
                            <div className="eb-ticket-stat-label">Rejetés</div>
                        </div>
                    </div>
                </div>

                {/* Layout en deux colonnes */}
                <div className="eb-ticket-split">
                    {/* ---------- Colonne gauche : file d'attente ---------- */}
                    <div className="eb-queue-panel">
                        <div className="eb-queue-head">
                            <div className="eb-queue-title">
                                <div className="eb-queue-title-icon"><ListOrdered size={18} /></div>
                                File d'attente
                            </div>
                            <span className="eb-queue-count">{data.length} ticket(s)</span>
                        </div>

                        <div className="eb-queue-search">
                            <SearchInput
                                onSearch={() => LoadData(true)}
                                size="lg"
                                placeholder="Rechercher un ticket..."
                            />
                        </div>

                        {data.length === 0 ? (
                            <div className="eb-queue-empty">
                                <div className="eb-queue-empty-icon"><Hourglass size={44} /></div>
                                <div className="eb-queue-empty-title">Aucun ticket dans la file</div>
                                <div className="eb-queue-empty-subtitle">Les nouveaux tickets apparaîtront ici automatiquement.</div>
                            </div>
                        ) : (
                            <div className="eb-queue-list">
                                {data.map((record: any, index: number) => {
                                    const interact = canInteract(record);
                                    const isMine = String(record.CodeOperateur).replace(" (👱🏼‍♂️ Moi)", "") == user.CodeU;
                                    const isCurrent = record.CodeT === curentTicket;
                                    return (
                                        <div
                                            key={record.CodeT}
                                            className={`eb-queue-item${isMine ? ' is-mine' : ''}${isCurrent ? ' is-current' : ''}`}
                                        >
                                            <div className="eb-queue-item-rank">{index + 1}</div>
                                            <div className="eb-queue-item-number">{record.CodeT || '...'}</div>
                                            <div className="eb-queue-item-meta">
                                                <div className="eb-queue-item-meta-row">
                                                    <User2 size="1em" />
                                                    <span>Généré par <strong>{record.CodeU || '...'}</strong></span>
                                                </div>
                                                <div className="eb-queue-item-meta-row">
                                                    <Clock size="1em" />
                                                    <span>{record.DateCreatee || '...'}</span>
                                                </div>
                                                {record.CodeOperateur && (record.Statut == 4 || record.Statut == 5) && (
                                                    <div className="eb-queue-item-meta-row eb-queue-item-caller">
                                                        <Megaphone size="1em" />
                                                        <span>Appelé par <strong>{String(record.CodeOperateur).replace(" (👱🏼‍♂️ Moi)", "")}{isMine ? ' (Moi)' : ''}</strong></span>
                                                    </div>
                                                )}
                                            </div>
                                            <StatusBadge statut={record.Statut} />
                                            <div className="eb-queue-item-actions">
                                                {interact ? (
                                                    <>
                                                        {calling && isCurrent ? (
                                                            <span className="inline-flex items-center justify-center w-[30px] h-[30px]">
                                                                <Loader2 size={18} className="animate-spin text-[var(--eb-primary)]" />
                                                            </span>
                                                        ) : (
                                                            <IconButton
                                                                tooltip="Appeler le client"
                                                                color="primary"
                                                                className="call-btn border border-[var(--eb-border)]"
                                                                size={30}
                                                                onClick={() => CallClient(record.CodeT, record.CodeU)}
                                                            >
                                                                <Mic size={16} />
                                                            </IconButton>
                                                        )}
                                                        <IconButton
                                                            tooltip="Valider"
                                                            color="success"
                                                            className="validate-btn border border-[var(--eb-border)]"
                                                            size={30}
                                                            onClick={() => ValidateOpe(record)}
                                                        >
                                                            <Check size={16} />
                                                        </IconButton>
                                                        <Tooltip title="Transférer">
                                                            <span>
                                                                <TranfertOpe disabled={false} reccord={record} />
                                                            </span>
                                                        </Tooltip>
                                                        <IconButton
                                                            tooltip="Rejeter"
                                                            color="danger"
                                                            className="reject-btn border border-[var(--eb-border)]"
                                                            size={30}
                                                            onClick={() => RejetOpe(record)}
                                                        >
                                                            <Trash2 size={16} />
                                                        </IconButton>
                                                    </>
                                                ) : (
                                                    <>
                                                        <IconButton
                                                            tooltip={`Déjà appelé par ${record.CodeOperateur}`}
                                                            color="primary"
                                                            className="call-btn border border-[var(--eb-border)]"
                                                            size={30}
                                                            disabled
                                                        >
                                                            <MicOff size={16} />
                                                        </IconButton>
                                                        <IconButton
                                                            tooltip="Valider"
                                                            color="success"
                                                            className="validate-btn border border-[var(--eb-border)]"
                                                            size={30}
                                                            disabled
                                                        >
                                                            <Check size={16} />
                                                        </IconButton>
                                                        <Tooltip title="Transférer">
                                                            <span>
                                                                <TranfertOpe disabled={true} reccord={record} />
                                                            </span>
                                                        </Tooltip>
                                                        <IconButton
                                                            tooltip="Rejeter"
                                                            color="danger"
                                                            className="reject-btn border border-[var(--eb-border)]"
                                                            size={30}
                                                            disabled
                                                        >
                                                            <Trash2 size={16} />
                                                        </IconButton>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {/* ---------- Colonne droite : ticket prioritaire ---------- */}
                    <div className="eb-focus-panel">
                        {/* Carte du ticket en cours d'appel */}
                        <div className="eb-focus-card">
                            <div className="eb-focus-label">
                                {currentRecord ? 'Ticket en cours d\'appel' : 'Aucun ticket appelé'}
                            </div>
                            {curentTicket ? (
                                <div className="eb-focus-number">{curentTicket}</div>
                            ) : (
                                <div className="eb-focus-number-empty">Sélectionnez un ticket à appeler</div>
                            )}

                            {currentRecord && (
                                <>
                                    <div className="eb-focus-meta">
                                        <div className="eb-focus-meta-row">
                                            <User2 size={16} />
                                            <span>Généré par <strong>{currentRecord.CodeU || '...'}</strong></span>
                                        </div>
                                        <div className="eb-focus-meta-row">
                                            <Clock size={16} />
                                            <span>{currentRecord.DateCreatee || '...'}</span>
                                        </div>
                                        <div className="eb-focus-meta-row eb-focus-caller">
                                            <Megaphone size={16} />
                                            <span>Appelé par <strong>{currentRecord.CodeOperateur || user.CodeU}{String(currentRecord.CodeOperateur).replace(" (👱🏼‍♂️ Moi)", "") == user.CodeU ? ' (Moi)' : ''}</strong></span>
                                        </div>
                                        {currentRecord.UpdateCount != null && (
                                            <div className="eb-focus-meta-row">
                                                <Repeat size={16} />
                                                <span>Appelé <strong>{currentRecord.UpdateCount}</strong> fois</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="eb-focus-actions">
                                        <Button
                                            variant="white"
                                            className="!bg-emerald-600/35 !border-emerald-500/60 hover:!bg-emerald-600/55"
                                            startIcon={<CheckCircle2 size={16} />}
                                            onClick={() => ValidateOpe(currentRecord)}
                                        >
                                            Valider
                                        </Button>
                                        <Button
                                            variant="white"
                                            className="!bg-red-600/30 !border-red-500/55 hover:!bg-red-600/50"
                                            startIcon={<XCircle size={16} />}
                                            onClick={() => RejetOpe(currentRecord)}
                                        >
                                            Rejeter
                                        </Button>
                                        <div className="full">
                                            <TranfertOpe fullWidth disabled={false} reccord={currentRecord} />
                                        </div>
                                        <div className="full">
                                            <Button
                                                variant="white"
                                                className="w-full !bg-white/20 !border-white/40 hover:!bg-white/30"
                                                loading={calling}
                                                startIcon={<Mic size={16} />}
                                                onClick={() => CallClient(currentRecord.CodeT, currentRecord.CodeU)}
                                            >
                                                Appeler
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Carte prochain ticket */}
                        {nextRecord && !currentRecord && (
                            <div className="eb-next-card is-active">
                                <div className="eb-next-info">
                                    <div className="eb-next-label">Prochain ticket</div>
                                    <div className="eb-next-number">{nextRecord.CodeT}</div>
                                    <div className="eb-next-meta">
                                        Généré par {nextRecord.CodeU || '...'}
                                    </div>
                                </div>
                                <div className="eb-next-action">
                                    <Button
                                        size="sm"
                                        className="min-w-[110px]"
                                        startIcon={<Mic size={16} />}
                                        onClick={() => CallClient(nextRecord.CodeT, nextRecord.CodeU)}
                                    >
                                        Appeler
                                    </Button>
                                </div>
                            </div>
                        )}

                        {nextRecord && currentRecord && nextRecord.CodeT !== currentRecord.CodeT && (
                            <div className="eb-next-card">
                                <div className="eb-next-info">
                                    <div className="eb-next-label">Prochain ticket</div>
                                    <div className="eb-next-number">{nextRecord.CodeT}</div>
                                    <div className="eb-next-meta">
                                        Généré par {nextRecord.CodeU || '...'}
                                    </div>
                                </div>
                                <div className="eb-next-action">
                                    <Button
                                        size="sm"
                                        className="min-w-[110px]"
                                        startIcon={<ArrowRight size={16} />}
                                        onClick={() => CallClient(nextRecord.CodeT, nextRecord.CodeU)}
                                    >
                                        Suivant
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <TableStatusBar count={data.length} loading={loading} onRefresh={() => LoadData(true)} />
            </div>
        </Spin>
    );
}
